
function onSmsClick(sms_rec_id, sms_module, sms_mob, sms_name) {
    $("#mySMSModal").remove();

    const myKeyVals = {
        id: sms_rec_id,
        module: capitalizeFirstLetter(sms_module),
        mob: sms_mob,
        name: sms_name
    };

    $.ajax({
        url: 'index.php?entryPoint=SMSIntegrationController',
        type: 'POST',
        data: myKeyVals,
        success: function (result) {
            // Insert modal container and content
            $("#sms_icon").after(`
                <div id="mySMSModal" class="modal fade right" data-bs-backdrop="static" data-bs-keyboard="false"></div>
            `);
            $("#mySMSModal").html(result);
            $("#mySMSModal").modal('show');
            $(".modal-backdrop").hide();

            // Start chat and template fetch
            sms_chat(sms_mob);
            get_sms_templates(sms_module);

            // Auto-refresh chat every 10 seconds
            const chat_show_timer = setInterval(function () {
                sms_chat(sms_mob);
            }, 10000);

            // Close handler
            $(".close").click(function () {
                $("#mySMSModal").html("");
                $("#mySMSModal").modal('hide');
                clearInterval(chat_show_timer);
            });
        },
        error: function () {
            console.error('Error: Unable to open SMS modal.');
        }
    });
}

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function sms_chat(sms_mob) {
    $.ajax({
        url: 'index.php?entryPoint=SmsChatIntegrationController',
        type: 'POST',
        data: { mob: sms_mob },
        success: function (res) {
            if (res) {
                $("#msg_card_body").html(res);
            } else {
                $("#msg_card_body").html("No data found");
            }
        },
        error: function () {
            console.error('Error: Unable to fetch chat.');
        }
    });
}

function get_sms_templates(sms_module) {
    $.ajax({
        url: 'index.php?entryPoint=SmsGetTemplateController',
        type: 'POST',
        data: { module_name: sms_module },
        success: function (res) {
            $("#template_dropdown").html(res);
        },
        error: function () {
            console.error('Error: Unable to fetch SMS templates.');
        }
    });
}
